export default __webpack_public_path__ + "static/media/bluebin.4717eabb.svg";